import PropTypes from 'prop-types';
import styles from './RailItem.module.css';

// One item of the transaction rail (Figma `16780:56087`): icon with its label underneath.
function RailItem({ icon, label, active = false, pressed, onClick, onMouseEnter, railItemId }) {
    return (
        <button
            type="button"
            className={`${styles['rail-item']}${active ? ` ${styles['rail-item--active']}` : ''}`}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            {...(railItemId && { 'data-rail-item': railItemId })}
            {...(pressed !== undefined && { 'aria-pressed': pressed })}
        >
            <span className={styles['rail-item__icon']} aria-hidden="true">
                {icon}
            </span>
            <span className={styles['rail-item__label']}>{label}</span>
        </button>
    );
}

RailItem.propTypes = {
    icon: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    active: PropTypes.bool,
    pressed: PropTypes.bool,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    // Lets other UI find this item, e.g. to return focus to it (`[data-rail-item="protocol"]`).
    railItemId: PropTypes.string,
};

export default RailItem;
